import { render } from "./AdminInvoices.vue?vue&type=template&id=65617988&scoped=true"
import script from "./AdminInvoices.vue?vue&type=script&lang=js"
export * from "./AdminInvoices.vue?vue&type=script&lang=js"

import "./AdminInvoices.vue?vue&type=style&index=0&id=65617988&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65617988"]])

export default __exports__